import { Actions } from '../externals';

export const LISTENER_AND_SUBSCRIPTION_READY = Actions.LISTENER_AND_SUBSCRIPTION_READY;
export const UPGRADE_CTA_CLICK = Actions.UPGRADE_CTA_CLICK;
export const UPGRADE_DISCOUNT_PLAN_LINK_CLICKED = Actions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED;
export const CANCEL_SUBSCRIPTION = Actions.CANCEL_SUBSCRIPTION;
export const SELECT_OFFER = 'SELECT_OFFER' as const;
export const SELECT_PAYMENT_PROVIDER = 'SELECT_PAYMENT_PROVIDER' as const;
export const CLEAR_SELECTED_OFFER = 'CLEAR_SELECTED_OFFER' as const;
export const ANONYMOUS_START_TRIAL_CLICKED = Actions.ANONYMOUS_START_TRIAL_CLICKED;
export const UPGRADE_OFFERED = Actions.UPGRADE_OFFERED;
export const DELETE_CREDIT_CARD = 'DELETE_CREDIT_CARD' as const;
export const GET_CREDIT_CARD_V2 = 'GET_CREDIT_CARD_V2' as const;
export const GET_CREDIT_CARD_V2_SUCCESS = 'GET_CREDIT_CARD_V2_SUCCESS' as const;
export const ACQUIRE_OFFER = 'ACQUIRE_OFFER' as const;
export const PREPARE_TO_ACQUIRE_OFFER = 'PREPARE_TO_ACQUIRE_OFFER' as const;
export const FINISH_ACQUIRE_PRODUCT = 'FINISH_ACQUIRE_PRODUCT' as const;
export const ACQUIRE_OFFER_SUCCESS = Actions.ACQUIRE_OFFER_SUCCESS;
export const GET_SUBSCRIPTION_INFO_V2 = 'GET_SUBSCRIPTION_INFO_V2' as const;
export const GET_AVAILABLE_PRODUCTS = 'GET_AVAILABLE_PRODUCTS' as const;
export const RESUBSCRIBE = 'RESUBSCRIBE' as const;
export const UPDATE_CREDIT_CARD_INFO = 'UPDATE_CREDIT_CARD_INFO' as const;
export const TOGGLE_SWITCHING_PLANS = 'TOGGLE_SWITCHING_PLANS' as const;
export const CREDIT_CARD_FORM_RESET = 'CREDIT_CARD_FORM_RESET' as const;
export const UPDATING_BILLING_INFO = 'UPDATING_BILLING_INFO' as const;
export const STOP_UPDATING_BILLING_INFO = 'STOP_UPDATING_BILLING_INFO' as const;
export const RESET_UPDATED_BILLING_INFO = 'RESET_UPDATED_BILLING_INFO' as const;
export const RESET_PAYPAL_STATUS = 'RESET_PAYPAL_STATUS' as const;
export const RESET_INVALID_CREDIT_CARD_STATUS = 'RESET_INVALID_CREDIT_CARD_STATUS' as const;
export const IS_ANONYMOUS_UPGRADE = 'IS_ANONYMOUS_UPGRADE' as const;
export const CANCEL_CURRENT_PRODUCT = 'CANCEL_CURRENT_PRODUCT' as const;
export const IS_PENDING_PAYMENT_UPDATE = 'IS_PENDING_PAYMENT_UPDATE' as const;
export const LOAD_PAYMENTS_DATA = 'LOAD_PAYMENTS_DATA' as const;
export const EXIT_FROM_FAMILY_PLAN = 'EXIT_FROM_FAMILY_PLAN' as const;
export const FAMILY_PLAN_CREATE_INVITE = 'FAMILY_PLAN_CREATE_INVITE' as const;
export const FAMILY_PLAN_RESEND_INVITE = 'FAMILY_PLAN_RESEND_INVITE' as const;
export const FAMILY_PLAN_REVOKE_INVITE = 'FAMILY_PLAN_REVOKE_INVITE' as const;
export const FAMILY_PLAN_REMOVE_CHILD = 'FAMILY_PLAN_REMOVE_CHILD' as const;
export const START_MANAGING_FAMILY_PLAN_ACCOUNTS = 'START_MANAGING_FAMILY_PLAN_ACCOUNTS' as const;
export const STOP_MANAGING_FAMILY_PLAN_ACCOUNTS = 'STOP_MANAGING_FAMILY_PLAN_ACCOUNTS' as const;
export const PROCESS_UPGRADE_AUTHENTICATION = 'PROCESS_UPGRADE_AUTHENTICATION' as const;
export const PROCESS_UPGRADE = 'PROCESS_UPGRADE' as const;
export const ENTER_SUBSCRIPTION_MANAGEMENT = 'ENTER_SUBSCRIPTION_MANAGEMENT' as const;
export const ENTER_FAMILY_PLAN_MANAGEMENT = 'ENTER_FAMILY_PLAN_MANAGEMENT' as const;
export const DISPLAY_MOBILE_MESSAGE = 'DISPLAY_MOBILE_MESSAGE' as const;
export const CLEAR_MOBILE_MESSAGE = 'CLEAR_MOBILE_MESSAGE' as const;
export const OPEN_SWITCH_PLAN_MODAL = 'OPEN_SWITCH_PLAN_MODAL' as const;
export const OPEN_CANCEL_SUBSCRIPTION_MODAL = 'OPEN_CANCEL_SUBSCRIPTION_MODAL' as const;
export const SWITCH_PLAN = 'SWITCH_PLAN' as const;
export const LOG_UPGRADE_PAGE_EVENT = 'LOG_UPGRADE_PAGE_EVENT' as const;
export const PAYPAL_COMPLETE = 'PAYPAL_COMPLETE' as const;
export const SET_PAYPAL_COMPLETE = 'SET_PAYPAL_COMPLETE' as const;
export const WAIT_FOR_SUBSCRIPTION_INFO = 'WAIT_FOR_SUBSCRIPTION_INFO' as const;
export const PARTNER_UPGRADE_CONFIRM_LISTENER = 'PARTNER_UPGRADE_CONFIRM_LISTENER' as const;
export const UPGRADE_CONFIRMATION = 'UPGRADE_CONFIRMATION' as const;
export const REQUEST_PARTNER_UPGRADE = 'REQUEST_PARTNER_UPGRADE' as const;
export const ENTER_PARTNER_UPGRADE_FLOW = 'ENTER_PARTNER_UPGRADE_FLOW' as const;
export const INITIATE_PARTNER_UPGRADE = 'INITIATE_PARTNER_UPGRADE' as const;
export const EXIT_PARTNER_UPGRADE = 'EXIT_PARTNER_UPGRADE' as const;
export const REVERIFY_LINK_CLICKED = 'REVERIFY_LINK_CLICKED' as const;
